/**
 * 远程认证考卷导入
 */
import React from 'react';
import { connect } from 'dva';
import { ExportExcel } from '@/components/index'
import { modelUtils } from '@/utils'
import { component_tool, framework_tool, utils_tool } from '@/tool'

let { WizTypography, WizModal, WizSpin, WizTreeSelect, WizCard, WizAntdForm, WizButton, Wizmessage, WizIcon,WizProgress } = component_tool;
let { WizContainer, WizFileUpload } = framework_tool;
const { Paragraph } = WizTypography;
const { Item } = WizAntdForm
let { excelUtils, Session } = utils_tool;

class RemoteAuthFileImport extends WizContainer {

  componentName = 'remoteAuthFileImport';

  constructor(props) {
    super(props);
    let initialValue = {};
    if (props.history.location && props.history.location.pathname === '/remoteAuth/remoteAuthList/remoteAuthFileImport') {
      if (props.history.location && props.history.location.record) {
        initialValue = props.history.location.record;
        Session.set('remoteAuthImport', initialValue)
      } else {
        initialValue = Session.get('remoteAuthImport') || {};
      }
    }
    this.state = {
      fileId: undefined,  //上传文件id
      file: undefined,
      fileData: undefined
    }
    this.initialValue = initialValue;
    this.itemCol = {
      wrapperCol: {
        xs: { span: 10, offset: 1 },
        sm: { span: 10, offset: 1 },
      },
      labelCol: {
        xs: { span: 5, offset: 0 },
        sm: { span: 5, offset: 0 },
      },
    }
  }

  _componentDidMount() {

  }

  _handldImport(nextProps, nextState) {
    let o = nextProps['remoteAuthImport']
    if (o['success']) {
      let data = o['data'];
      let str = data.replace(/<br\/>/g, "\n")
      WizModal.success({
        title: '导入结果',
        content: <p style={{ whiteSpace: "pre-line" }}>{str}</p>
      })
      this.jumpPage('replace', '/remoteAuth/remoteAuthList');
      return true;
    } else {
      wizNotice.error(o.msg)
      //失败修改file表状态为失败,暂无该方法

      return false;
    }
  }

  propsAndStateOnChange = {

    remoteAuthImport: this._handldImport.bind(this),
  }


  filterData(fileData) {
    let newFileData = [];
    if (fileData) {
      let parser = new DOMParser();
      let doc = parser.parseFromString(fileData[0], "text/xml");
      let array = doc.getElementsByTagName("tr");//所有tr
      for (let i = 1; i < array.length; i++) {
        let tds = array[i].children;
        let trData = [];
        tds.forEach(element => {
          let tdObj = {};
          tdObj.id = element.id;
          tdObj.rowspan = element.getAttribute('rowspan');
          tdObj.text = element.innerHTML;
          trData.push(tdObj)
        });
        newFileData.push(trData);
      }
    }
    return newFileData
  }

  /**
   * 提交按钮
   */
  _submitBtn() {
    let { fileId } = this.state
    if (fileId) {
      return (
        <Item label={' '} colon={false} {...this.itemCol}>
          <WizButton type='primary' onClick={this._submit.bind(this)}>上 传</WizButton>
        </Item>
      )
    }
  }

  /**上传校验 */
  _ossBeforeUpload(file) {
    let result = true;
    if (file.type.indexOf('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') == -1) {
      Wizmessage.error('只能上传xlsx文件,请重新选择!');
      result = false;
    }
    this.setState({
      fileId: undefined,
      file: file,
    }, () => {
      excelUtils.importExcel(
        { target: { files: [file] } },
        (fileData) => {
          this.setState({ fileData: fileData })
        },
        { dataFun: ['sheet_to_html'] }
      )
    }
    )
    return result;
  }

  onChange(file) {
    if (file && file[0]) {
      this.setState({
        fileId: file[0].fileId,
        file: file[0],
      })
    }
  }

  /**上传数据 */
  _submit() {
    let { fileId, fileData } = this.state;
    let fileDataJson = this.filterData(fileData)
    let apiPath = 'remoteAuth/import';
    this.doAction({
      path: apiPath,
      payload: {
        key: "remoteAuthImport",
        apiParams: {
          fileData: fileDataJson,
          fileId: fileId,
          remoteAuthId: this.initialValue.id,
          type: this.initialValue.type
        }
      }
    });
  }

  /** 上传的文件显示内容 */
  _fileChildren() {
    let icon = <WizIcon type="loading" style={{ fontSize: 14 }}/>
    let fileName = ''
    if(this.state.file && this.state.file.fileOriginalName){
      icon = <WizIcon type="paper-clip" />;
      fileName = this.state.file.fileOriginalName;
    } else if (this.state.file && this.state.file.name) {
      fileName =  this.state.file.name ;

    }
    //anticon anticon-loading
    return (
      <>
        <WizButton><WizIcon type="upload" /> 选择文件</WizButton>
        {
          this.state.file ?
            <div class=" ant-upload-list ant-upload-list-text">
              <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-text">
                <div class="ant-upload-list-item-info">
                  {icon}
                  <span class="ant-upload-list-item-name ant-upload-list-item-name-icon-count-2"> {fileName} </span>
                </div>
              </div>
              {/* <WizProgress strokeColor={{ '0%': '#108ee9', '100%': '#87d068', }} status="active" percent={99.9} showInfo={false}/> */}
            </div> : <></>
        }
      </>
    )
  }


  _render() {
    const { treeData, orgNodeCategoryTree } = this.state
    let record = this.props.location.record;
    let id = "";
    let remoteAuthTemp = "";
    if (record) {
      id = record.id;
      remoteAuthTemp = record.type!=null && record.type===1 ? constants.files.excel_remoteAuthTempNew :record.type!=null && record.type===0 ? constants.files.excel_remoteAuthTemp: constants.files.excel_remoteAuthNevTemp
    }
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
      ]
    }
    let operateProps = {
      title: '考卷导入',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        href: remoteAuthTemp,
      },
      upload: {}
    }


    let { remoteAuthLoading } = this.props;
    let dataFun = ['sheet_to_html']
    return (
      <WizSpin tip={'文件上传中'} spinning={remoteAuthLoading}>

        <WizCard title={infoProps.title} icon='0'> {infoProps.text}</WizCard>
        <WizCard title={operateProps.title} icon='0'>
          <Item label={operateProps.template.label} {...this.itemCol}>
            <a download={operateProps.template.fileName} href={operateProps.template.href}>{operateProps.template.fileName}</a>
          </Item>
          <Item label={'选择文件'} {...this.itemCol}>
            <WizFileUpload
              accept={'.xlsx'} //, .xls
              beforeUpload={this._ossBeforeUpload.bind(this)}
              onChange={this.onChange.bind(this)}
              children={this._fileChildren()}
              showUploadList={false}
              uploadType={'system'}
            />
          </Item>
          {this._submitBtn()}
        </WizCard>
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { remoteAuth } = state;
  const remoteAuthImport = modelUtils.getModelEntity(remoteAuth, 'remoteAuthImport');

  //获取loading的方式
  const load = modelUtils.getLoadingState(state, 'remoteAuth')
  return {
    remoteAuthImport,
    ...load
  }
};

export default connect(mapStateToProps)(RemoteAuthFileImport);
